import type { FC, FormEvent } from "react";
import { MdClose } from "react-icons/md";
import { useAppContext } from "../contexts/AppContext";

const SearchBar: FC = () => {
    const { searchTerm, setSearchTerm, navigateToSave } = useAppContext();

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    };

    const handleBlankAreaDrop = (_event: React.DragEvent<HTMLDivElement>) => {
        _event.preventDefault();
        navigateToSave();
    };

    return (
        <div className="search-bar"
            onDragOver={(event) => {
                event.preventDefault();
            }}
            onDrop={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleBlankAreaDrop(event);
            }}
        >
            <form onSubmit={handleSubmit} className="search-form">
                <div className="search-input-wrapper">
                    <input
                        type="text"
                        placeholder="Enter text to search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />
                    {searchTerm && (
                        <button
                            type="button"
                            className="search-clear-button"
                            aria-label="Clear search"
                            title="Clear search"
                            onClick={() => setSearchTerm("")}
                        >
                            <MdClose />
                        </button>
                    )}
                </div>
                <button type="submit" className="find-button">
                    Find
                </button>
            </form>
        </div>
    );
};

export default SearchBar;
